import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters productsWrapper" };
const _hoisted_2 = { class: "col-12 px-md-3 px-0" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12 py-3 px-0 text-md-right text-center overflow-auto" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box = _resolveComponent("product-box");
    const _component_listing_pagination = _resolveComponent("listing-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentListedProducts, (product, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "singleProductBoxWrapper col-xl-4 col-lg-6 col-md-6 col-sm-6 mt-sm-3 mt-2 mb-lg-3 mb-0 px-sm-3 px-2"
                    }, [
                        _createVNode(_component_product_box, { product: product }, null, 8, ["product"])
                    ]));
                }), 128)),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_listing_pagination)
                ])
            ])
        ])
    ]));
}
